// extracted by mini-css-extract-plugin
module.exports = {"container":"AwardsSection_container__1uhdI"};